export default __webpack_public_path__ + "static/media/Logo.f1f12439.png";